export default function formatApiName(rawName: string) {
  return rawName
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^[^a-zA-Z0-9]+/, '')
    .replace(/[^a-zA-Z0-9]+$/, '')
    .toLowerCase()
}
